import React from 'react';
import { Button } from '../ui/button';
import { Label } from '../ui/label';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from '../ui/select';
import { Loader2 } from 'lucide-react';

export function QuickPhotoMode({
  capturedPhoto, chantierId, onChantierChange,
  chantiers, isProcessing, onSave, onCancel,
}) {
  return (
    <div className="space-y-4 py-4">
      {capturedPhoto && (
        <div className="relative aspect-video rounded-xl overflow-hidden bg-gray-100">
          <img
            src={URL.createObjectURL(capturedPhoto)}
            alt="Captured"
            className="w-full h-full object-cover"
          />
        </div>
      )}

      <div className="text-left">
        <Label>Chantier *</Label>
        <Select value={chantierId} onValueChange={onChantierChange}>
          <SelectTrigger className="mt-1 h-14 text-base" data-testid="quick-photo-chantier">
            <SelectValue placeholder="Sélectionner un chantier" />
          </SelectTrigger>
          <SelectContent position="popper" className="z-[100]">
            {chantiers.map(c => (
              <SelectItem key={c.id} value={c.id} className="py-3">{c.name}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="flex gap-3 pt-2">
        <Button variant="outline" onClick={onCancel} className="flex-1 h-14">
          Annuler
        </Button>
        <Button
          onClick={onSave}
          disabled={isProcessing || !chantierId}
          className="flex-1 h-14 bg-[#0055FF] hover:bg-blue-700"
          data-testid="quick-photo-save"
        >
          {isProcessing ? <Loader2 className="animate-spin" /> : 'Enregistrér'}
        </Button>
      </div>
    </div>
  );
}
